import { motion } from "framer-motion";

const chapters = [
  {
    no: "01",
    title: "Single source, three essentials.",
    body: "From a construction site sealing a glass façade, to a kitchen cooking the morning batter, to a laundry running its first load — we keep the supply chain simple. One relationship, three trusted brands.",
  },
  {
    no: "02",
    title: "Only authorised, only genuine.",
    body: "As authorised dealers of DOWSIL and appointed distributors of Chennai Express and Wopper, every product we move is genuine, traceable and backed by the brand. No greys, no compromises.",
  },
  {
    no: "03",
    title: "Built for volume, priced for business.",
    body: "Whether you order a single carton or supply an entire district, our logistics and pricing scale with you. Fast dispatch from Coimbatore across Tamil Nadu.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Manifesto() {
  return (
    <section
      id="about"
      className="relative z-10 mx-auto max-w-[1400px] px-6 lg:px-10 py-28 lg:py-40"
      data-testid="manifesto-section"
    >
      <div className="mb-20 max-w-2xl">
        <p className="overline mb-6">Why V.S.V. Agencies</p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter leading-[1]">
          A trading house built on <span className="italic">trust</span>, range and reliability.
        </h2>
      </div>

      <div className="space-y-px">
        {chapters.map((c, i) => (
          <motion.article
            key={c.no}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.4 }}
            className="group relative grid grid-cols-1 gap-6 border-t border-white/10 py-12 md:grid-cols-12 md:gap-10"
            data-testid={`manifesto-chapter-${c.no}`}
          >
            <div className="md:col-span-3">
              <span className="font-display text-6xl lg:text-8xl font-light text-white/10 transition-colors duration-500 group-hover:text-white/25">
                {c.no}
              </span>
            </div>
            <h3 className="font-display text-2xl lg:text-4xl font-light tracking-tight md:col-span-4">
              {c.title}
            </h3>
            <p className="text-white/55 leading-relaxed md:col-span-5 md:text-lg">
              {c.body}
            </p>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
